
export type TimeFormatString = string;
export type DateString = string;

export interface VideoCall {
	id: string;
	createdAt: Date;
	doctorId: string;
}

export interface RoutineMeasurement {
	takeMeasureTime: any
}

export interface MeasurementSchedule {
	createdAt: Date | any;
	routine: RoutineMeasurement[];
}

export interface DoctorNote {
	createdAt: DateString | Date;
	message: string;
}

import { isProxy } from '@vue/reactivity';
import {DateTime} from 'luxon';
export const now = () : DateTime => {
	return DateTime.local()
}

export function formatDateTime(datetime : Date | string | any) : string {
	if (typeof datetime === 'string' ) {
		return DateTime.fromJSDate(new Date(datetime)).toFormat('dd/MM h:mm a')
	} else if (isProxy(datetime)) {
		return DateTime.fromJSDate(datetime.toDate()).toFormat('dd/MM h:mm a')
	} else if (datetime instanceof Date) {
		return DateTime.fromJSDate(datetime).toFormat('dd/MM h:mm a')
	}
	return DateTime.fromJSDate(datetime).toFormat('dd/MM h:mm a')
}
export function formatSeconds(seconds : number) : string {
	return DateTime.fromSeconds(seconds).toFormat('dd/MM h:mm')
}

export function isEmpty(value : undefined | string | Object) {
	if (typeof value === 'undefined') return true
	if (typeof value === 'string') {
		return value === ''
	} else {
		for (const v of Object.values(value)) {
			if (v === undefined) return true
			if (typeof v === 'string' && v === '') {
				return true
			}
		}
		return false
	}
} 

export function formatDecimalValue(value: number): number {
  return Math.ceil(value * 100) / 100; 
}
